import React from 'react'
import { IoTimerOutline } from 'react-icons/io5'

const SessionExpiredModal = ({ handleLogout }) => {
  return (
    <div className="fixed inset-0 bg-black/95 flex items-center justify-center z-[100000] backdrop-blur-sm">
      <div className="bg-white dark:bg-dark rounded-xl shadow-2xl w-full max-w-[450px] p-8 relative animate-in fade-in zoom-in duration-300">
        <div className="flex flex-col items-center text-center">
          <div className="w-20 h-20 bg-yellowcolor/10 rounded-full flex items-center justify-center mb-6 border-4 border-yellowcolor/5">
            <IoTimerOutline className="h-10 w-10 text-yellowcolor" />
          </div>

          <h2 className="text-2xl font-bold mb-3 dark:text-white">
            Session Expired
          </h2>
          <p className="text-gray-600 text-base dark:text-gray-400 mb-8 leading-relaxed">
            Your session has timed out due to inactivity or an invalid token. Please log in again to continue managing your harvests.
          </p>

          <button 
            className="w-full h-14 rounded-xl bg-yellowcolor hover:bg-yellowcolor/90 text-black font-bold text-lg shadow-lg shadow-yellowcolor/20 transition-all active:scale-[0.98]" 
            onClick={handleLogout}
          >
            Logout & Re-login
          </button>
        </div>
      </div>
    </div>
  )
}

export default SessionExpiredModal
